import React from 'react';
import { BookOpen, Clock, ExternalLink } from 'lucide-react';
import { BLOG_POSTS } from '../../data/config';
import WidgetContainer from '../WidgetContainer';

const BlogPosts = ({ delay = 0 }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <WidgetContainer size="2x1" delay={delay}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-cream-100">Latest Articles</h3>
        <div className="flex items-center gap-2">
          <a
            href="#posts"
            className="text-xs text-coffee-300 hover:text-cream-100 transition-colors font-semibold"
          >
            View All
          </a>
          <BookOpen className="w-5 h-5 text-coffee-300" />
        </div>
      </div>

      <div className="space-y-4">
        {BLOG_POSTS.slice(0, 3).map((post) => (
          <a
            key={post.id}
            href={post.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-3 rounded-lg bg-coffee-700/20 hover:bg-coffee-700/40 transition-all duration-300 hover:translate-x-1 group"
          >
            <div className="flex items-start justify-between gap-2 mb-2">
              <h4 className="text-sm font-semibold text-cream-100 group-hover:text-coffee-300 transition-colors">
                {post.title}
              </h4>
              <ExternalLink className="w-3 h-3 text-coffee-300 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <p className="text-xs text-coffee-200 mb-2 line-clamp-2">
              {post.excerpt}
            </p>
            <div className="flex items-center gap-3 text-xs text-coffee-300">
              <span>{formatDate(post.date)}</span>
              <span>•</span>
              <span className="flex items-center gap-1">
                <Clock className="w-3 h-3" />
                {post.readTime}
              </span>
            </div>
          </a>
        ))}
      </div>
    </WidgetContainer>
  );
};

export default BlogPosts;
